export default __webpack_public_path__ + "static/media/Newsletter 003.9b2af608.png";